import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import Table from './Table'

import {
  onSectionRender,
  onHeaderClick,
  onMenuHide,
  onApplyFilter,
  onInputHeaderValueChange,
  onColumnReorder,
} from 'containers/Project/ElasticSearch/actions'

import {
  listSelector,
  menuActiveStateSelector,
  columnIndexStateSelector,
  currentHeaderFilterValue,
  currentSortValue,
  sortEnabled,
  sortIndexStateSelector,
  headerFilterValue,
  sortByStateSelector,
  inputHeaderSourceStateSelector,
} from 'containers/Project/ElasticSearch/selectors'


const mapStateToProps = (state) => {
  return {
    list: listSelector(state),
    active: menuActiveStateSelector(state),
    columnIndex: columnIndexStateSelector(state),
    headerFilterValue: currentHeaderFilterValue(state),
    sortBy: currentSortValue(state),
    sortEnabled: sortEnabled(state),
    sortIndex: sortIndexStateSelector(state),
    sortByValue: sortByStateSelector(state),
    enabledFilters: headerFilterValue(state),
    inputHeaderSource: inputHeaderSourceStateSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSectionRender: (start, stop) => dispatch(onSectionRender(start, stop)),
    onHeaderClick: (columnIndex) => dispatch(onHeaderClick(columnIndex)),
    onMenuHide: () => dispatch(onMenuHide()),
    onApplyFilter: (columnIndex, filter, sort) => dispatch(onApplyFilter(columnIndex, filter, sort)),
    onInputChange: (value) => dispatch(onInputHeaderValueChange(value)),
    onColumnReorder: (columnsMoved, targetIndex) => dispatch(onColumnReorder(columnsMoved, targetIndex))
  }
}

class TableSearch extends Component {
  onSectionRendered = ( rowStartIndex, rowStopIndex ) => {
    this.props.onSectionRender(
      rowStartIndex,
      rowStopIndex
    )
  }

  onApply = ({ filter, sort }) => this.props.onApplyFilter(
    this.props.columnIndex,
    filter,
    sort
  )

  render() {
    const {
      active,
      list,
      inputHeaderSource,
      onHeaderClick,
      onMenuHide,
      onColumnReorder,
      columnIndex,
      headerFilterValue,
      sortBy,
      sortEnabled,
      sortIndex,
      sortByValue,
      enabledFilters,
      onInputChange,
    } = this.props
    return (
      <Table
        active={active}
        onSectionRendered={this.onSectionRendered}
        onHeaderClick={onHeaderClick}
        onMenuHide={onMenuHide}
        onColumnReorder={onColumnReorder}
        list={list}
        columnIndex={columnIndex}
        onClick={this.onApply}
        onKeyPress={this.onApply}
        value={headerFilterValue}
        sortBy={sortBy}
        sortByValue={sortByValue}
        sortEnabled={sortEnabled}
        sortIndex={sortIndex}
        enabledFilters={enabledFilters}
        onChange={onInputChange}
        inputHeaderSource={inputHeaderSource}
      />
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withConnect,
)

export default enhance(TableSearch)
